import { Directive, Input, OnInit, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[azDisabled]',
    standalone: false
})
export class DisabledDirective implements OnInit {
  private _azDisabled:boolean = false;
  get azDisabled():boolean {
    return this._azDisabled;
  }
  @Input() set azDisabled(val:boolean){
    if(this._azDisabled !== val){
      this.switchDisable(val);
    }
    this._azDisabled= val;

  }

  constructor(@Self() private control: NgControl) { }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

  }

  switchDisable(disabled:boolean) {
    if(this.control.control){
      if(disabled && this.control.control.enabled){
        this.control.control.disable();
      }
      if(!disabled && this.control.control.disabled){
        this.control.control.enable();
      }
    }
  }

}
